module.exports = __webpack_public_path__ + "img/edit_columns.8e15021b.svg";